import _ from "lodash";

import Widget from "components/Widget";
import { Button } from "antd";


const CompanyCard = ({ shipyard, title, clickEvent }) => {
  return (
    <Widget styleName="gx-card-profile">
      <div className="ant-card-head">
        <span className="ant-card-head-title gx-mb-1">{title}</span>
      </div>
      <div className="gx-pb-md-3">
        <div className="">
          <div className="gx-media-body gx-featured-content">
            <div className="gx-featured-content-left">
              <a
                href={`/app/shipyards/${shipyard.id}-${_.kebabCase(shipyard.name)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h3 className="gx-text-primary gx-mt-sm-auto  gx-pointer">{shipyard.name}</h3>
              </a>
              {
                shipyard?.company?.web &&
                <div className="gx-text-grey gx-fs-sm">
                  <span>{shipyard?.company?.web}</span>
                </div>
              }

              <div>
                {clickEvent &&
                  <Button type="primary" onClick={clickEvent}>
                    Claim
                  </Button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Widget>
  )
};

export default CompanyCard;